<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术系统</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col :span="5">
          <span class="title_class">裁判系统</span>
        </el-col>
        <el-col :span="19" style="text-align: right;">
            <!-- <span class="reset-btn" @click="showReset">重置总决选比赛状态</span> -->
        </el-col>
      </el-row>
      <div class="row">
        <div class="col" v-for="(item,i) in menus2" :key="item.id" >
          <div class="system-btn system-btn1" :class="hasPerms(item.authorityFlag) ? 'card-background'+(i+1) : 'no-permission'" @click="handleToRM(item)">
            <i class="icon iconfont" :class="item.icon"></i>
            <div>
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class" style="margin-bottom: 15px;">学术系统</span>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="5" v-for="(item, i) in menus" :key="item.id">
          <tool :item="item" :index="i"></tool>
        </el-col>
      </el-row>
      <!-- <div class="row">
        <div class="col" v-for="(item, i) in menus" :key="item.id" >
          <div class="system-btn system-btn2" @click="handleTo(item.path)">
            <i class="icon iconfont" :class="item.icon"></i>
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div> -->
    </el-card>
    <el-dialog
      title="重置总决选比赛状态"
      :visible.sync="resetVisible"
      width="400px"
      :before-close="handleClose">
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="60px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="类型" prop="isGroup">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.isGroup"
              >
                <el-option label="小组赛" value="1"></el-option>
                <el-option label="无组别" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.season"
                @change="seasonChange"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="queryForm.isGroup === '1'">
            <el-form-item label="组别" prop="quizLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.level"
              >
                <el-option
                  v-for="item in groups"
                  :key="item.id"
                  :label="item.formName"
                  :value="item.formLevel"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="密码" prop="quizLevel">
              <el-input v-model="pwd" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" style="display: block;margin: 20px auto 0;" @click="resetFn">确定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { hasPermission } from '@/permission/index.js'

export default {
  data () {
    return {
      menus: [
        {
          id: 3,
          path: '/academic_Management/paper',
          rightTitle: '试卷管理',
          rightDesc: '查看试卷及题目详情',
          authorityFlag: this.$chnEngStatusCode.paper,
          menuTag: '1',
          icon: 'icon-shijuan'
        },
        {
          id: 1,
          path: '/academic_Management/academic_font_management/academic_font_management?status=0',
          rightTitle: '词库管理',
          rightDesc: '单项增、改、删，批量导入导出',
          authorityFlag: this.$chnEngStatusCode.academic_font_management,
          menuTag: '2',
          icon: 'icon-package-search'
        },
        {
          id: 2,
          path: '/academic_Management/academic_course_management/academic_course_management',
          rightTitle: '课程管理',
          rightDesc: '新增、修改、查看课程信息',
          authorityFlag: this.$chnEngStatusCode.academic_course_management,
          menuTag: '3',
          icon: 'icon-kecheng'
        }
      ],
      menus2: [
        {
          id: 5,
          path: '/academic_Management/rm',
          group: 3,
          // title: '城市复选',
          // desc: '复选裁判系统',
          title: '区域决选',
          desc: '区域决选裁判系统',
          icon: 'icon-chujia',
          authorityFlag: this.$chnEngStatusCode.rm
        },
        {
          id: 3,
          path: '/academic_Management/refereeFinalManagement',
          // path: '/academic_Management/rm',
          group: 1,
          title: '总决选小组赛',
          desc: '三轮裁判系统',
          icon: 'icon-chujia',
          authorityFlag: this.$chnEngStatusCode.rm
        },
        {
          id: 4,
          path: '/academic_Management/rm',
          group: 2,
          title: '总决选无组别挑战赛',
          desc: '两轮裁判系统',
          icon: 'icon-chujia',
          authorityFlag: this.$chnEngStatusCode.rm
        }

        // {
        //   id: 6,
        //   path: '/academic_Management/rm',
        //   group: 4,
        //   title: '总决选资格挑战赛',
        //   desc: '资格赛裁判系统',
        //   icon: 'icon-chujia',
        //   authorityFlag: this.$chnEngStatusCode.rm
        // }
      ],
      resetVisible: false,
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        isGroup: '1',
        level: ''
      },
      dict_season: [],
      groups: [],
      pwd: '',
      chooseSeason: ''
    }
  },
  created () {
    // this.init()
  },
  methods: {
    handleTo (path) {
      if (path) {
        this.$router.push({ path })
      }
    },
    init () {
      this.$userInfo.getDataList(this, 't_season').then(value => {
        this.dict_season = value
        // this.queryForm.season = value[0].dictValue
        this.getGroups(0)
      })
    },
    seasonChange () {
      this.quizLevel = ''
      this.getGroups(0)
    },
    getGroups (type) {
      // type:有组别 0初始化调用 组别默认第一条，1按所选组别
      // 无组别直接 选第一条
      const { season, activityType, isGroup } = this.queryForm
      this.$http.get('national/queryNationalGroupFormLevel', { params: { season, activityType, isGroup } }).then(res => {
        if (res.code === 200) {
          this.groups = res.data
        }
      })
    },
    handleToRM (item) {
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (item.path) {
        this.$router.push({
          path: item.path,
          query: {
            group: item.group
          }
        })
      }
    },
    showReset () {
      console.log('1qazxsw2')
      this.resetVisible = true
    },
    handleClose () {
      this.resetVisible = false
    },
    resetFn () {
      if (this.queryForm.isGroup === '2') {
        this.queryForm.level = 5
      }
      if (this.pwd === '1qazxsw2') {
        this.$http.get('slabForm/resetMatch', { params: this.queryForm }).then(res => {
          if (res.code === 200) {
            this.$message.success('重置成功')
            this.handleClose()
          }
        })
      } else {
        this.$message.warning('密码错误')
      }
    },
    hasPerms: function (flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(flag) // & !this.disabled
    }
  }
}
</script>
<style scoped lang="less">
.system-btn{
  border-radius: 8px;
  padding: 20px 0;
  margin-right: 20px;
  cursor: pointer;
  &:hover{
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
  .icon{
    font-size: 30px;
  }
  .title{
    font-size: 16px;
    margin-bottom: 6px;
  }
  .desc{
    font-size: 12px;
  }
}
.row{
  overflow: hidden;
}
.col{
  float: left;
}
.system-btn2{
  border: 1px solid #0277ff;
  background-color: #F4F5FC;
  width: 200px;
  text-align: center;
  .icon{
    color: #0277ff;
  }
  .title{
    color: #0277ff;
    margin-top: 6px;
  }
  .desc{
    color: #7b7b82;
  }
}
.system-btn1{
  color: #fff;
  display: flex;
  align-items: center;
  width: 260px;

  .icon{
    padding: 8px 10px;
    margin-left: 20px;
    margin-right: 20px;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 100%;
    color: transparent;
  }
}
.card-background1 {
  .icon{
    color: #f66c98;
  }
}

.card-background2 {
  .icon{
    color: #f6b122;
  }
}

.card-background3 {
  .icon{
    color: #37b9f6;
  }
}

.card-background4 {
  .icon{
    color: #fa5856;
  }
}
.reset-btn{
  font-size: 12px;
  color: #efefef;
  cursor: pointer;
  text-decoration: underline;
  &:hover{
    color: #ccc;
  }
}
</style>
